// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"8210e2a5","130":"55267909","167":"95ab3294","270":"be7c3222","287":"bbd91283","390":"d4c4cb8f","453":"f24ed662","470":"a4202419","617":"86e93348","719":"47261cc0","728":"613865df","748":"caf39d09","795":"04e9ce22","911":"e6e814f2","927":"9c11d62e"}[chunkId] + ".chunk.js";
};